import { TextField } from "@mui/material"
import React, { Fragment, useContext, useEffect, useState } from "react"
import { Dropdown, DropdownButton, InputGroup } from "react-bootstrap"
import { eur_to_satoshis, satoshis_to_eur, toFixed } from "../helpers/convert_bsv_tokens"
import { Row } from "./Row"
import { getLog } from "../helpers/helpers"
import { Loader } from "./Loader"



/**
 * props:
 * 		- name
 * 		- active
 * 		- onClick
 */
function DropdownItem(props) {
	const other_props = {
		active: props.active,
	}

	function onClick() {
		props.onClick(props.name)
	}

	return (
		<Dropdown.Item onClick={onClick} {...other_props}>
			{props.name}
		</Dropdown.Item>
	)
}


function val_to_sats(activeName, new_value, bsvprice) {
	var new_nbsatoshis = 0

	if (activeName.includes("satoshis")) {
		new_nbsatoshis = new_value
	}
	else if (activeName.includes("EUR")) {
		new_nbsatoshis = eur_to_satoshis(new_value, bsvprice)
	}
	else { // "BSV"
		new_nbsatoshis = new_value * 1e8
	}

	// safety check if we have a non-int satoshis value
	if (new_nbsatoshis != parseInt(new_nbsatoshis)) {
		new_nbsatoshis = parseInt(new_nbsatoshis) + 1
	}
	return new_nbsatoshis
}


/**
 *  props:
 * 	  - context					the UserContext
 *	  - onChange (function)   	callback receiving: (nb_satoshis, inputType)
										inputType in "satoshis,"BSV","EUR"
*/
export default function InputAmountBSV(props) {

	const context = props.context

	const classname = "InputAmountBSV: "
	const function_id = classname
	const log = getLog(function_id)

	const [activeName, set_activeName] = useState("EUR")
	const [placeholder, set_placeholder] = useState("ex: 20.35")

	const [inputValue, set_inputValue] = useState("")
	const [jsx_convert_display, set_jsx_convert_display] = useState(null)


	function onChangeUnit(new_activeName) {

		set_activeName(new_activeName)

		if (new_activeName.includes("satoshis")) {
			set_placeholder("ex: 50 000")
		}
		else if (new_activeName.includes("EUR")) {
			set_placeholder("ex: 20.35")
		}
		else { // BSV
			set_placeholder("ex: 0.35")
		}

		updateConvertDisplay(
			val_to_sats(new_activeName, inputValue, context.bsvprice),
			new_activeName
		)
	}

	// if unit changed (or bsvprice loaded), call props.onchange() callback
	useEffect(() => {
		if (!context.bsvprice || !inputValue) return
		const new_nbsatoshis = val_to_sats(activeName, inputValue, context.bsvprice)
		log("useEffect():", inputValue, activeName, "=>", new_nbsatoshis, "satoshis")
		updateConvertDisplay(new_nbsatoshis)
		props.onChange(new_nbsatoshis, activeName)
	},
		[activeName, context.bsvprice] // do not add more here or you will create infinite loops !
	)


	function onChangeInputBSV(event) {
		const new_value = event.target.value

		set_inputValue(new_value)
		if (!context.bsvprice) return

		const new_nbsatoshis = val_to_sats(activeName, new_value, context.bsvprice)

		log("onChange():", new_value, activeName, "=>", new_nbsatoshis, "satoshis")

		updateConvertDisplay(new_nbsatoshis)

		// callback
		props.onChange(new_nbsatoshis, activeName)
	}


	function updateConvertDisplay(bsv_nbsatoshis, bsv_inputType = activeName) {
		set_jsx_convert_display("") // reset

		// add satoshis value in eur
		if (bsv_nbsatoshis && bsv_nbsatoshis > 0) {
			if (!context.bsvprice) {
				set_jsx_convert_display(<Loader small />)
				return
			}
			const eur_val = satoshis_to_eur(bsv_nbsatoshis, context.bsvprice)

			var jsx_convert_display = null
			if (bsv_inputType) {
				if (bsv_inputType.includes("EUR")) {
					// eur to satoshis to bsv
					jsx_convert_display = <Fragment>
						{eur_val}€  = {bsv_nbsatoshis} satoshis  = {bsv_nbsatoshis / 1e8} BSV
					</Fragment>
				} else if (bsv_inputType.includes("satoshis")) {
					// satoshis to bsv to eur
					jsx_convert_display = <Fragment>
						{bsv_nbsatoshis} satoshis  = {toFixed(bsv_nbsatoshis / 1e8)} BSV  = {eur_val}€
					</Fragment>
				} else {
					// bsv to satoshis to eur
					jsx_convert_display = <Fragment>
						{toFixed(bsv_nbsatoshis / 1e8)} BSV  = {bsv_nbsatoshis} satoshis  = {eur_val} €
					</Fragment>
				}
			}

			set_jsx_convert_display(jsx_convert_display)
		}
	}


	/* note: if we wanted to input to include '€' at the beginning or end, this is how to do it:
	const valueDisplay = (value).toLocaleString('fr-FR', {style: 'currency', currency: 'EUR'})
	<input ...
	  onKeyDown={handleKeyDown} // handle typing as keys down and convert to the actual float value
	  value={valueDisplay}
	  ...>
	*/

	return (
		// <RowWithTitle title="Montant de BSV à envoyer">
		<Row>

			<InputGroup as="div" style={{ padding: 0, fontFamily: "system-ui" }}>

				{/* <input 
					type='text'
					value={inputValue}
					onChange={onChange}
					id='inputValue'
					placeholder={placeholder}
					className='item'
				/> */}

				<TextField fullWidth
					id="outlined-basic" variant="outlined"
					label="Montant de BSV à envoyer"
					value={inputValue ? inputValue : ""}
					onChange={onChangeInputBSV}
					placeholder={placeholder}
					// disabled={context.bsvprice?false:true}
					helperText={jsx_convert_display}
					InputProps={{
						endAdornment:
							<DropdownButton
								id="dropdown-basic-button"
								title={activeName}
								variant="secondary"
								className="mt-2"
								menuVariant="dark"
							>
								<DropdownItem name="satoshis" onClick={() => { onChangeUnit("satoshis") }} />
								<DropdownItem name="EUR" onClick={() => { onChangeUnit("EUR") }} />
								<DropdownItem name="BSV" onClick={() => { onChangeUnit("BSV") }} />

							</DropdownButton>
					}}
				/>

			</InputGroup>

		</Row>
	)
}
